define("shared/components/shared/credentials/advanced-display-status", ["exports", "@ember/component", "@ember/array", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _array, _object, _service, _utils, _component2, _tracking, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/array",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{action @close}}
    @closable={{false}}
    data-test-id={{@data-test-id}}
    class="qa--cred_refresh_modal"
    ...attributes
    {{did-insert this.initCredentials}}
    {{track
      "viewed-credential-status"
      page=@source
      action_needed=this.actionsNeeded
      refresh_needed_count=this.missingFeatures.length
      refresh_needed_list=this.missingFeaturesLabels
    }}
    as |modal|
  >
    <modal.card @closeIcon={{false}} @portrait={{true}}>
      <modal.card-header>
        {{#if this.showSuccess}}
          <h2 class="o--modalHeader__title">
            {{t "credentials.advanced.success"}}
          </h2>
        {{else if this.invalidUserToken}}
          <h2 class="o--modalHeader__title">
            {{t "credentials.advanced.title"}}
          </h2>
          <p class="u--p__t__xs">
            {{t "credentials.advanced.subcopy_expired_user_token" profileName=this.brokenProfileNames}}
          </p>
          <Shared::Link
            @href="https://help.later.com/hc/articles/1500001601602"
            @text={{t "credentials.advanced.help_article"}}
          />
        {{else}}
          <h2 class="o--modalHeader__title">
            {{t "credentials.advanced.title"}}
          </h2>
          <p class="u--p__t__xs">
            {{t "credentials.advanced.subcopy_owner"}}
          </p>
          <Shared::Link
            @href="https://help.later.com/hc/articles/1500001601602"
            @text={{t "credentials.advanced.help_article"}}
          />
        {{/if}}
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        {{#if this.showSuccess}}
          {{#each this.fixedProfiles as |profile|}}
            <Shared::Credentials::AdvancedDisplayStatus::ProfileListItem
              @onError={{fn @onError profile}}
              @onSuccess={{this.onSuccess}}
              @originalMissingFeatures={{this.missingFeatures}}
              @originalProfiles={{this.brokenProfiles}}
              @path="cluster.labs.credential_status"
              @profile={{profile}}
              @source={{@source}}
              @success={{true}}
            />
          {{/each}}
        {{/if}}
        {{#each this.brokenProfiles as |profile|}}
          <Shared::Credentials::AdvancedDisplayStatus::ProfileListItem
            @onError={{fn @onError profile}}
            @onSuccess={{this.onSuccess}}
            @originalMissingFeatures={{this.missingFeatures}}
            @originalProfiles={{this.brokenProfiles}}
            @path="cluster.labs.credential_status"
            @profile={{profile}}
            @source={{@source}}
          />
        {{/each}}
        {{#if this.missingFeatures}}
          <div class="o--card u--m__t__md">
            <div class="o--cardBody u--p__lr">
              <p class="u--text--bold u--m__b">
                {{#if this.singleSocialProfile}}
                  {{t
                    "shared_phrases.feature_refresh_required.missing_features"
                    profileType=this.singleSocialProfile.accountType
                  }}
                {{else}}
                  {{t "shared_phrases.feature_refresh_required.missing_features_fallback"}}
                {{/if}}
              </p>
              <ul class="u--listUnstyle u--row">
                {{#each this.missingFeatures as |missingFeature|}}
                  <li class="u--col__6">
                    {{svg-jar "warning" class="o--icon o--icon--danger u--m__b__xs"}}
                    {{missingFeature.name}}
                    {{#if
                      (or
                        (and (eq missingFeature.name "Analytics") this.showPartialAnalytics)
                        (and (eq missingFeature.name "Auto Publish") this.cannotAutoPublish)
                      )
                    }}
                      *
                    {{/if}}
                  </li>
                {{/each}}
              </ul>
              {{#if this.showPartialAnalytics}}
                <p>
                  {{t "credentials.profile_list.partial_analytics"}}
                </p>
              {{/if}}
              {{#if this.cannotAutoPublish}}
                <p>
                  {{t "credentials.profile_list.auto_publish_availability_personal"}}
                </p>
              {{/if}}
            </div>
          </div>
        {{/if}}
        {{#if this.refreshedFeatures}}
          <div class="o--card u--m__t__md">
            <div class="o--cardBody u--p__lr">
              <p class="u--text--bold u--m__b">
                {{t "credentials.advanced.features_now_working"}}
              </p>
              <ul class="u--listUnstyle u--row">
                {{#each this.refreshedFeatures as |feature|}}
                  <li class="u--col__6">
                    {{svg-jar "verified" class="o--icon o--icon--success u--m__b__xs"}}
                    {{feature.name}}
                  </li>
                {{/each}}
              </ul>
            </div>
          </div>
        {{/if}}
        {{#if this.brokenProfiles}}
          <p class="u--text--sm u--text--light u--m__t__md u--m__b__0 u--float--right">
            {{t "credentials.advanced.show_next_time" day=this.nextCredentialDisplayDate}}
          </p>
        {{/if}}
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @additional="block"
          @onClick={{this.closeAdvanceDisplayStatusModal}}
          @text="Close"
          @variant="outline"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "6K2Wn+zW",
    "block": "[[[8,[39,0],[[16,\"data-test-id\",[30,1]],[24,0,\"qa--cred_refresh_modal\"],[17,2],[4,[38,2],[[30,0,[\"initCredentials\"]]],null],[4,[38,3],[\"viewed-credential-status\"],[[\"page\",\"action_needed\",\"refresh_needed_count\",\"refresh_needed_list\"],[[30,4],[30,0,[\"actionsNeeded\"]],[30,0,[\"missingFeatures\",\"length\"]],[30,0,[\"missingFeaturesLabels\"]]]]]],[[\"@close\",\"@closable\"],[[28,[37,1],[[30,0],[30,3]],null],false]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,5,[\"card\"]],null,[[\"@closeIcon\",\"@portrait\"],[false,true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,5,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"showSuccess\"]],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"credentials.advanced.success\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"invalidUserToken\"]],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"credentials.advanced.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--p__t__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"credentials.advanced.subcopy_expired_user_token\"],[[\"profileName\"],[[30,0,[\"brokenProfileNames\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,6],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/1500001601602\",[28,[37,5],[\"credentials.advanced.help_article\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"credentials.advanced.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--p__t__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"credentials.advanced.subcopy_owner\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,6],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/1500001601602\",[28,[37,5],[\"credentials.advanced.help_article\"],null]]],null],[1,\"\\n      \"]],[]]]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,5,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"showSuccess\"]],[[[42,[28,[37,8],[[28,[37,8],[[30,0,[\"fixedProfiles\"]]],null]],null],null,[[[1,\"          \"],[8,[39,9],null,[[\"@onError\",\"@onSuccess\",\"@originalMissingFeatures\",\"@originalProfiles\",\"@path\",\"@profile\",\"@source\",\"@success\"],[[28,[37,10],[[30,7],[30,6]],null],[30,0,[\"onSuccess\"]],[30,0,[\"missingFeatures\"]],[30,0,[\"brokenProfiles\"]],\"cluster.labs.credential_status\",[30,6],[30,4],true]],null],[1,\"\\n\"]],[6]],null]],[]],null],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"brokenProfiles\"]]],null]],null],null,[[[1,\"        \"],[8,[39,9],null,[[\"@onError\",\"@onSuccess\",\"@originalMissingFeatures\",\"@originalProfiles\",\"@path\",\"@profile\",\"@source\"],[[28,[37,10],[[30,7],[30,8]],null],[30,0,[\"onSuccess\"]],[30,0,[\"missingFeatures\"]],[30,0,[\"brokenProfiles\"]],\"cluster.labs.credential_status\",[30,8],[30,4]]],null],[1,\"\\n\"]],[8]],null],[41,[30,0,[\"missingFeatures\"]],[[[1,\"        \"],[10,0],[14,0,\"o--card u--m__t__md\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__b\"],[12],[1,\"\\n\"],[41,[30,0,[\"singleSocialProfile\"]],[[[1,\"                \"],[1,[28,[35,5],[\"shared_phrases.feature_refresh_required.missing_features\"],[[\"profileType\"],[[30,0,[\"singleSocialProfile\",\"accountType\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,5],[\"shared_phrases.feature_refresh_required.missing_features_fallback\"],null]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"missingFeatures\"]]],null]],null],null,[[[1,\"                \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                  \"],[1,[28,[35,11],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__b__xs\"]]]],[1,\"\\n                  \"],[1,[30,9,[\"name\"]]],[1,\"\\n\"],[41,[28,[37,12],[[28,[37,13],[[28,[37,14],[[30,9,[\"name\"]],\"Analytics\"],null],[30,0,[\"showPartialAnalytics\"]]],null],[28,[37,13],[[28,[37,14],[[30,9,[\"name\"]],\"Auto Publish\"],null],[30,0,[\"cannotAutoPublish\"]]],null]],null],[[[1,\"                    *\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n\"]],[9]],null],[1,\"            \"],[13],[1,\"\\n\"],[41,[30,0,[\"showPartialAnalytics\"]],[[[1,\"              \"],[10,2],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"credentials.profile_list.partial_analytics\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"cannotAutoPublish\"]],[[[1,\"              \"],[10,2],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"credentials.profile_list.auto_publish_availability_personal\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"refreshedFeatures\"]],[[[1,\"        \"],[10,0],[14,0,\"o--card u--m__t__md\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__b\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"credentials.advanced.features_now_working\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"refreshedFeatures\"]]],null]],null],null,[[[1,\"                \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                  \"],[1,[28,[35,11],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success u--m__b__xs\"]]]],[1,\"\\n                  \"],[1,[30,10,[\"name\"]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[10]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"brokenProfiles\"]],[[[1,\"        \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__t__md u--m__b__0 u--float--right\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"credentials.advanced.show_next_time\"],[[\"day\"],[[30,0,[\"nextCredentialDisplayDate\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,5,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,15],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"closeAdvanceDisplayStatusModal\"]],\"Close\",\"outline\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[5]]]]]],[\"@data-test-id\",\"&attrs\",\"@close\",\"@source\",\"modal\",\"profile\",\"@onError\",\"profile\",\"missingFeature\",\"feature\"],false,[\"shared/modal\",\"action\",\"did-insert\",\"track\",\"if\",\"t\",\"shared/link\",\"each\",\"-track-array\",\"shared/credentials/advanced-display-status/profile-list-item\",\"fn\",\"svg-jar\",\"or\",\"and\",\"eq\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/credentials/advanced-display-status.hbs",
    "isStrictMode": false
  });
  let AdvancedDisplayStatusComponent = _exports.default = (_class = class AdvancedDisplayStatusComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "refreshed", _descriptor, this);
      _initializerDefineProperty(this, "refreshedFeatures", _descriptor2, this);
      _initializerDefineProperty(this, "fixedProfiles", _descriptor3, this);
      _defineProperty(this, "MAX_EXPIRY_TIME_IN_HOURS", 720);
      _initializerDefineProperty(this, "auth", _descriptor4, this);
      _initializerDefineProperty(this, "credentialStatus", _descriptor5, this);
      _initializerDefineProperty(this, "localStorageManager", _descriptor6, this);
    }
    get activeProfiles() {
      return this.credentialStatus.activeProfiles;
    }
    get brokenProfiles() {
      return this.credentialStatus.brokenProfiles;
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get hasErrors() {
      return this.credentialStatus.hasErrors;
    }
    get hasMissingFeatures() {
      return this.credentialStatus.hasMissingFeatures;
    }
    get invalidUserToken() {
      return this.credentialStatus.invalidUserFacebookToken;
    }
    get isAccountOwner() {
      return this.credentialStatus.isAccountOwner;
    }
    get missingFeatures() {
      return this.credentialStatus.missingFeatures;
    }
    get needsRefresh() {
      return this.credentialStatus.needsRefresh;
    }
    get nextCredentialDisplayDate() {
      return this.credentialStatus.nextCredentialDisplayDate;
    }
    get successfulRefresh() {
      return this.credentialStatus.successfulRefresh;
    }
    get missingFeaturesLabels() {
      return this.missingFeatures?.map(feature => feature.name);
    }
    get actionsNeeded() {
      if (this.invalidUserToken && this.needsRefresh) {
        return 'connect & refresh';
      } else if (this.invalidUserToken) {
        return 'connect';
      }
      return 'refresh';
    }
    get profilesWithoutAutopublish() {
      return this.brokenProfiles?.filter(profile => !profile.isInstagramBusiness);
    }
    get showSuccess() {
      return this.successfulRefresh && !this.credentialStatus.hasMissingFeatures || !this.credentialStatus.needsRefresh;
    }
    get personalProfiles() {
      return this.brokenProfiles?.filter(profile => profile.instagramProfileType === 'Personal');
    }
    get cannotAutoPublish() {
      return (0, _utils.isPresent)(this.profilesWithoutAutopublish);
    }
    get brokenProfileNames() {
      return this.brokenProfiles?.map(profile => profile.nickname).join(',');
    }
    get showPartialAnalytics() {
      const features = this.missingFeatures?.some(feature => feature.name === 'Analytics');
      return features && this.args.source === 'analytics';
    }

    // Note: The 'socialProfiles' arg can be a single SocialProfile, an array of SocialProfiles, or undefined
    get singleSocialProfile() {
      if (Array.isArray(this.args.socialProfiles) && this.args.socialProfiles.length === 1) {
        return this.args.socialProfiles[0];
      }
      if (!Array.isArray(this.args.socialProfiles) && this.args.socialProfiles) {
        return this.args.socialProfiles;
      }
      return undefined;
    }
    initCredentials() {
      this.credentialStatus.initState(this.args.socialProfiles);
    }
    async onSuccess() {
      let missingFeatures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let fixedProfiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      await this.credentialStatus.initState(this.args.socialProfiles);
      this.fixedProfiles = fixedProfiles;
      this.refreshedFeatures = missingFeatures.filter(feature => !this.missingFeatures.includes(feature));
      if (this.refreshedFeatures.length === 0) {
        this.args.onError();
      }
    }
    closeAdvanceDisplayStatusModal() {
      this._setCloseTime();
      this.args.close();
    }
    _setCloseTime() {
      this.credentialStatus.initState(this.brokenProfiles);
      if (this.brokenProfiles.length == 0) return;
      const uid = this.currentUser.id;
      const closeTime = (0, _timeFormat.timestamp)();
      this.localStorageManager.setItem(`prevDisplayDate_${uid}`, closeTime, this.MAX_EXPIRY_TIME_IN_HOURS);
      const prevShownTime = this.localStorageManager.getItem(`nextCredentialDisplayDate_${uid}`);
      this.localStorageManager.setItem(`nextCredentialDisplayDate_${uid}`, prevShownTime + 1, this.MAX_EXPIRY_TIME_IN_HOURS);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "refreshed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "refreshedFeatures", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fixedProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "localStorageManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "initCredentials", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "initCredentials"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSuccess", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeAdvanceDisplayStatusModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAdvanceDisplayStatusModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AdvancedDisplayStatusComponent);
});